import { api } from '../../../api';
import { AuthResponse } from './types';

const AUTH_TAG = 'Auth';

export const authApi = api.enhanceEndpoints({ addTagTypes: [AUTH_TAG] }).injectEndpoints({
  endpoints: (build) => ({
    handleGoogleCode: build.mutation<AuthResponse, { code: string }>({
      query: ({ code }) => ({
        method: 'POST',
        url: 'auth/register/google/',
        body: { code }
      })
    }),
    validateToken: build.mutation<AuthResponse, { token: string }>({
      query: ({ token }) => ({
        method: 'POST',
        url: 'auth/token/verify/',
        body: { token }
      })
    }),
    refreshToken: build.mutation<AuthResponse, { refresh: string }>({
      query: ({ refresh }) => ({
        method: 'POST',
        url: 'auth/token/refresh/',
        body: { refresh }
      })
    }),
    login: build.mutation<AuthResponse, { email: string; password: string }>({
      query: ({ email, password }) => ({
        method: 'POST',
        url: 'auth/login/',
        body: { email, password }
      })
    }),
    register: build.mutation<
      AuthResponse,
      { email: string; password: string; firstName: string; lastName: string }
    >({
      query: (args) => ({
        method: 'POST',
        url: 'auth/register/',
        body: {
          email: args.email,
          password1: args.password,
          first_name: args.firstName,
          last_name: args.lastName
        }
      })
    }),
    logout: build.mutation<void, void>({
      query: () => ({
        method: 'POST',
        url: 'auth/logout/'
      })
    }),
    emailToResetPassword: build.mutation<void, { email: string }>({
      query: ({ email }) => ({
        method: 'POST',
        url: 'auth/password/reset/',
        body: { email }
      })
    }),
    resetPassword: build.mutation<void, { newPassword: string; uid: string; token: string }>({
      query: ({ newPassword, uid, token }) => ({
        method: 'POST',
        url: 'auth/password/reset/confirm/',
        body: {
          new_password1: newPassword,
          new_password2: newPassword,
          uid,
          token
        }
      })
    })
  })
});

export const {
  useHandleGoogleCodeMutation,
  useLoginMutation,
  useValidateTokenMutation,
  useLogoutMutation,
  useRegisterMutation,
  useResetPasswordMutation,
  useEmailToResetPasswordMutation
} = authApi;
